<template>
  <p class="text-lg">{{ $t('aboutGoldenResidencyDetails') }}</p>
</template>

<script setup></script>

<style lang="scss" scoped></style>
